module.exports = __webpack_public_path__ + "img/slide4.bc808d39.jpg";